export default __webpack_public_path__ + "static/media/imageIcon.b9105032.png";